import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import BannerWithBreadcrumb from '../components/BannerWithBreadcrumb';
import './About.css';

const OurStory = () => (
  <div className="about-page">
    <BannerWithBreadcrumb
      title="Our Story"
      breadcrumbItems={[
        { label: 'Home', link: '/' },
        { label: 'About Us', link: '/about' },
        { label: 'Our Story' }
      ]}
    />
    <section className="content-section">
      <Container>
        <Row className="justify-content-center mb-5">
          <Col lg={8} className="text-center">
            <h2 className="mb-4">How We Started</h2>
            <p className="lead">
              Blist was born from a simple idea: to make discovering and connecting with local businesses easy, transparent, and enjoyable for everyone. Our founders, passionate about supporting small businesses and empowering communities, set out to build a platform that brings people and businesses together.
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center align-items-center mb-5">
          <Col md={6} className="mb-4 mb-md-0">
            <Card className="shadow-sm border-0">
              <Card.Body>
                <h4>Our Mission</h4>
                <p>
                  We believe every business has a story worth sharing. Our mission is to help local businesses thrive by making them visible, accessible, and trusted in the digital world. We’re committed to building a directory that’s not just a list, but a community.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="shadow-sm border-0">
              <Card.Body>
                <h4>Our Values</h4>
                <ul>
                  <li>Community First</li>
                  <li>Transparency & Trust</li>
                  <li>Innovation & Simplicity</li>
                  <li>Empowering Local Businesses</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <h3 className="mb-3">Meet Our Team</h3>
            <p>
              We’re a small, passionate team of designers, developers, and business lovers. We work every day to make Blist better for you and your community. Thank you for being part of our story!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  </div>
);

export default OurStory; 